<script>
  import { Route } from "tinro";
  import Landing from "./routes/Landing/index.svelte";
  import Tasks from "./routes/Tasks/index.svelte";
  import ArchivedTasks from "./routes/Tasks/archivedTasks.svelte";
  import CallBack from "./auth/Callback.svelte";
  import Install from "./routes/Install.svelte";
  import Navbar from "./components/navbar.svelte";
  import Transactionhistory from "./routes/TransactionHistory/index.svelte";
  import Notifications from "./routes/Notifications/index.svelte";
  import Login from "./routes/Login.svelte";
  import AccountSetting from "./routes/AccountSetting/index.svelte";
  import PrivacyandPolicy from "./routes/Privacyandpolicy/index.svelte";
  import Guard from "./components/Guard.svelte";
  import TaskItemDetails from "./routes/SingleTaskDetails/index.svelte";
  import FAQ from "./routes/FAQ/index.svelte";
  import Signup from "./routes/Signup.svelte";
  import SupportPage from "./routes/SupportPage/index.svelte";
  import { lang } from "./store/store";
  import { user } from "./firebase";
  let createTask = false;
  $: console.log(createTask);
</script>

<Route firstmatch path="/*">
  <Route path="/signup">
    <Signup />
  </Route>
  <Route path="/login">
    <Login />
  </Route>
  <Route path="/callback">
    <CallBack />
  </Route>
  <Route path="/install">
    <Install />
  </Route>

  <Route>
    <Guard>
      <Navbar bind:createTask />
      <div class="container">
        <Route path="/">
          <Landing />
        </Route>
        <Route path="/tasks">
          <Tasks bind:createTask />
        </Route>

        <!-- <Route path="/support">
					<SupportPage />
				</Route> -->
        <!-- <Route path="/FAQ">
					<FAQ />
				</Route> -->
        <Route path="/transaction-history">
          <Transactionhistory />
        </Route>
        <Route path="/notifications">
          <Notifications />
        </Route>
        <Route path="/account">
          <AccountSetting />
        </Route>
        <Route path="/archivedtasks">
          <ArchivedTasks />
        </Route>
        <!-- <Route path="/privacy-and-policy">
					<PrivacyandPolicy />
				</Route> -->
        <Route path="/TaskItemDetails/:taskRef" let:meta>
          <TaskItemDetails TaskRef={meta.params.taskRef} />
        </Route>
      </div>
    </Guard>
  </Route>
</Route>

<style>
  .container {
    padding-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: var(--backgroundColor);
  }
</style>
